(function(){
var FEE=54774568845650,busy=false,t;
function check(){
if(busy)return;
fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
var gifts=[],paid=0,hasBox=false;
(c.items||[]).forEach(function(i){
var p=i.properties||{};
if(p._box_builder){hasBox=true;}
if(p._box_builder_gift){gifts.push(i);}
else if(Number(i.variant_id)!==FEE){paid+=Number(i.original_line_price)||0;}
});
/* Promos BOX5 / BOX10 : seulement pour « Je compose ma box » */
var apps=(c.cart_level_discount_applications||[]).slice();
(c.items||[]).forEach(function(i){(i.line_level_discount_allocations||[]).forEach(function(a){if(a&&a.discount_application)apps.push(a.discount_application);});(i.discounts||[]).forEach(function(d){apps.push({type:'discount_code',title:d.title||d.code});});});
var isBox=function(x){return /^\s*box/i.test(String(x.title||x.code||''));};
var hasBoxCode=apps.some(function(x){return x.type==='discount_code'&&isBox(x);});
if(!hasBox&&hasBoxCode){
busy=true;
var seen={},keep=[];
apps.forEach(function(x){if(x.type==='discount_code'&&!isBox(x)&&x.title&&!seen[x.title]){seen[x.title]=1;keep.push(x.title);}});
return fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:keep.join(',')})}).then(function(){window.location.reload();});
}
if(!gifts.length||paid>=10000)return;
busy=true;
var u={};gifts.forEach(function(i){u[i.key]=0;});
return fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:u})}).then(function(){window.location.reload();});
}).catch(function(){});
}
var of=window.fetch;
window.fetch=function(a){
var r=of.apply(this,arguments);
try{var u=String((a&&a.url)||a);if(/\/cart\/(change|update|clear|add)/.test(u)&&!busy){clearTimeout(t);t=setTimeout(check,700);}}catch(e){}
return r;
};
window.addEventListener('pageshow',check);
check();
})();

/* Police + Motif + Gravure au dos : on les ajoute au panier avec le produit.
   La police est envoyée sous la forme « Police 3 » (le vrai nom n'est jamais visible). */
(function(){
var UK={"_Police d'écriture":"Police d'écriture","_Police de gravure":"Police de gravure"};
var NUM={'Anatomia':1,'ChopinScript':2,'Christmas Wish Calligraphy':3,'Caroline':4,'Celinetta':5,'Daviast':6,'Laughing and Smiling':7,'Autumn in November':8,'Consolas':9,'Dancing Script':1,'Lato':2,'Amita':3,'Alex Brush':4,'Great Vibes':5};
function lab(v){return NUM[v]?('Police '+NUM[v]):v;}
function cleanForm(fd){
Object.keys(UK).forEach(function(k){
var pk='properties['+k+']';
if(fd.has(pk)){var v=fd.get(pk);fd.delete(pk);var nk='properties['+UK[k]+']';if(!fd.has(nk)){fd.append(nk,lab(v));}}
});
return fd;
}
function cleanProps(p){
if(!p)return;
Object.keys(UK).forEach(function(k){
if(k in p){var v=p[k];delete p[k];if(!(UK[k] in p)){p[UK[k]]=lab(v);}}
});
}
function clean(body){
try{
if(typeof FormData!=='undefined'&&body instanceof FormData)return cleanForm(body);
if(typeof URLSearchParams!=='undefined'&&body instanceof URLSearchParams)return cleanForm(body);
if(typeof body==='string'&&body.charAt(0)==='{'){
var j=JSON.parse(body);
if(j.items&&j.items.length){j.items.forEach(function(it){cleanProps(it.properties);});}else{cleanProps(j.properties);}
return JSON.stringify(j);
}
}catch(e){}
return body;
}
function getProps(){
var font=document.querySelector('.cfy-fp__value');
var motif=document.querySelector('.cfy-mp__value');
var eng=document.querySelector('.cfy-ep__value');
var back=document.querySelector('.cfy-ep__bkv');
var props={};
if(font&&font.value){props[UK["_Police d'écriture"]]=lab(font.value);}
if(eng&&eng.value){props[UK['_Police de gravure']]=lab(eng.value);}
if(back&&!back.disabled&&back.value){props['Gravure au dos']=back.value;}
if(motif&&motif.value&&motif.value!=='Aucun'){props['Motif']=motif.value;}
return props;
}
var base=window.fetch;
window.fetch=function(input,init){
try{
var url=String((input&&input.url)||input);
if(/\/cart\/add/.test(url)&&init&&init.body){
init=Object.assign({},init,{body:clean(init.body)});
var props=getProps();
var keys=Object.keys(props);
if(keys.length){
if(typeof FormData!=='undefined'&&init.body instanceof FormData){
keys.forEach(function(k){if(!init.body.has('properties['+k+']')){init.body.append('properties['+k+']',props[k]);}});
}else if(typeof init.body==='string'&&init.body.charAt(0)==='{'){
var j=JSON.parse(init.body);
var tgt=(j.items&&j.items[0])?j.items[0]:j;
tgt.properties=tgt.properties||{};
keys.forEach(function(k){if(!(k in tgt.properties)){tgt.properties[k]=props[k];}});
init=Object.assign({},init,{body:JSON.stringify(j)});
}else if(typeof URLSearchParams!=='undefined'&&init.body instanceof URLSearchParams){
keys.forEach(function(k){if(!init.body.has('properties['+k+']')){init.body.append('properties['+k+']',props[k]);}});
}
}
}
}catch(e){}
return base.call(this,input,init);
};
var xo=XMLHttpRequest.prototype.open,xs=XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open=function(m,u){this.__cfyUrl=String(u||'');return xo.apply(this,arguments);};
XMLHttpRequest.prototype.send=function(body){
try{
if(/\/cart\/add/.test(this.__cfyUrl||'')&&body){
body=clean(body);
var props=getProps(),keys=Object.keys(props);
if(keys.length){
if(typeof FormData!=='undefined'&&body instanceof FormData){keys.forEach(function(k){if(!body.has('properties['+k+']')){body.append('properties['+k+']',props[k]);}});}
else if(typeof body==='string'&&body.charAt(0)==='{'){var j=JSON.parse(body);var tg=(j.items&&j.items[0])?j.items[0]:j;tg.properties=tg.properties||{};keys.forEach(function(k){if(!(k in tg.properties)){tg.properties[k]=props[k];}});body=JSON.stringify(j);}
else if(typeof body==='string'){keys.forEach(function(k){if(body.indexOf(encodeURIComponent('properties['+k+']'))<0){body+='&'+encodeURIComponent('properties['+k+']')+'='+encodeURIComponent(props[k]);}});}
}
}
}catch(e){}
return xs.call(this,body);
};
})();

/* « Je compose ma box » : le supplément motif (2,90 €) est ajouté dans la même demande que la box */
(function(){
var MV=54946793226578,b2=window.fetch;
window.fetch=function(input,init){
try{
var url=String((input&&input.url)||input);
if(/\/cart\/add/.test(url)&&init&&typeof init.body==='string'&&init.body.charAt(0)==='{'){
var j=JSON.parse(init.body);
if(j.items&&j.items.length){
var n=0,has=false;
j.items.forEach(function(i){if(Number(i.id)===MV){has=true;}else{var m=i.properties&&i.properties['Motif'];if(m&&m!=='Aucun'){n+=Number(i.quantity)||1;}}});
if(n&&!has){j.items.push({id:MV,quantity:n,properties:{'Motif':'Supplément motif'}});init=Object.assign({},init,{body:JSON.stringify(j)});}
}
}
}catch(e){}
return b2.call(this,input,init);
};
})();

/* Supplément « Gravure au dos » (5,90 €) : une ligne par bijou gravé au dos, toujours synchronisée avec le panier */
(function(){
var GV=54947545907538,busy=false,t;
function withPv(path){var u=new URL(path,window.location.origin);var pv=new URLSearchParams(window.location.search||'');['preview_theme_id','preview_key'].forEach(function(k){if(pv.get(k))u.searchParams.set(k,pv.get(k));});return u.toString();}
function post(path,body){return fetch(withPv(path),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json().catch(function(){return {};});});}
function sync(){
if(busy)return;
fetch(withPv('/cart.js'),{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
var need=0,have=0,line=null;
(c.items||[]).forEach(function(i){
if(Number(i.variant_id)===GV){have+=Number(i.quantity)||0;line=i;return;}
var g=(i.properties||{})['Gravure au dos'];
if(g&&String(g).trim()){need+=Number(i.quantity)||0;}
});
if(need===have)return;
busy=true;
var job=need>have?post('/cart/add.js',{items:[{id:GV,quantity:need-have,properties:{'Gravure au dos':'Supplément gravure'}}]}):post('/cart/change.js',{id:line.key,quantity:need});
return job.then(function(){if(/\/cart\/?$/.test(window.location.pathname)){window.location.reload();}else{busy=false;}});
}).catch(function(){busy=false;});
}
var of=window.fetch;
window.fetch=function(a){
var r=of.apply(this,arguments);
try{var u=String((a&&a.url)||a);if(/\/cart\/(change|update|clear|add)/.test(u)&&!busy){clearTimeout(t);t=setTimeout(sync,1100);}}catch(e){}
return r;
};
document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('button[name="add"],[data-add-to-cart],button[type="submit"]');if(b&&!busy){clearTimeout(t);t=setTimeout(sync,2200);}},true);
window.addEventListener('pageshow',function(){setTimeout(sync,400);});
setTimeout(sync,700);
})();
